'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishOutgoingMessageFailure = exports.publishOutgoingMessageSuccess = exports.publishOutgoingMessage = exports.clearOutgoingMessages = exports.shiftOutgoingMessages = exports.enqueueOutgoingMessage = undefined;

var _underscore = require('underscore');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _reduxActions = require('redux-actions');

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enqueueOutgoingMessage = exports.enqueueOutgoingMessage = (0, _reduxActions.createAction)(_ActionTypes2.default.ENQUEUE_OUTGOING_MESSAGE);

var shiftOutgoingMessages = exports.shiftOutgoingMessages = (0, _reduxActions.createAction)(_ActionTypes2.default.SHIFT_OUTGOING_MESSAGES);

var clearOutgoingMessages = exports.clearOutgoingMessages = (0, _reduxActions.createAction)(_ActionTypes2.default.CLEAR_OUTGOING_MESSAGES);

var publishOutgoingMessage = exports.publishOutgoingMessage = (0, _reduxActions.createAction)(_ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE, _underscore.identity, function (data) {
  return _defineProperty({}, _strings.PUBNUB_KEY, data);
});

var publishOutgoingMessageSuccess = exports.publishOutgoingMessageSuccess = (0, _reduxActions.createAction)(_ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_SUCCESS, _underscore.identity, function (data) {
  return _defineProperty({}, _strings.PUBNUB_KEY, data);
});

var publishOutgoingMessageFailure = exports.publishOutgoingMessageFailure = (0, _reduxActions.createAction)(_ActionTypes2.default.PUBLISH_OUTGOING_MESSAGE_FAILURE, _underscore.identity, function (data) {
  return _defineProperty({}, _strings.PUBNUB_KEY, data);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/OutgoingMessageActions.js
// module id = 66
// module chunks = 0 1